"use client";

import { Accordion } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import { BundleProductDescription } from "./BundleProductDescription/BundleProductDescription";
import { BundleProductSpecification } from "./BundleProductSpecification/BundleProductSpecification";
import styles from "./BundleProductAccordion.module.scss";
import { RetiredStaticBundleComponent } from "../../../types/types";

type Props = {
  bundleComponent: RetiredStaticBundleComponent;
};

export const BundleProductAccordion = ({ bundleComponent }: Props) => {
  return (
    <>
      <div data-testid="bundleProduct:accordion">
        <Accordion size="medium">
          <AccordionItem
            id="bundle-accordion-description"
            className={styles.accordion}
            data-testid="bundleAccordion:description"
            header={
              <div className={styles.accordionTitle}>Product description</div>
            }
            onStateChange={undefined}
            aria-label="Product description"
          >
            <BundleProductDescription
              product={bundleComponent.variant.parentProduct}
            />
          </AccordionItem>
          <AccordionItem
            id="bundle-accordion-specification"
            className={styles.accordion}
            data-testid="bundleAccordion:specification"
            header={
              <div className={styles.accordionTitle}>Product specification</div>
            }
            onStateChange={undefined}
            aria-label="Product specification"
          >
            <BundleProductSpecification bundleComponent={bundleComponent} />
          </AccordionItem>
        </Accordion>
      </div>
    </>
  );
};
